export const FACEBOOK_API_VERSION = `v24.0`
